<template>
  <vue-splitter
    :margin="30"
    style="display: flex; height:  100%; overflow: hidden "
  >
    <group
      slot="left-pane"
      @choice="choice"
    />
    <group-config
      slot="right-pane"
      :group="cur_group"
    />
  </vue-splitter>
</template>

<script>
import GroupConfig from './EsimProfileGroupList/EsimProfileGroupConfig.vue'
import Group from './EsimProfileGroupList/EsimProfileGroupList.vue'
import VueSplitter from '@rmp135/vue-splitter'
export default {
  name: 'EsimProfileGroup',
  components: {
    GroupConfig,
    VueSplitter,
    Group
  },
  data () {
    return {
      new_group: '',
      cur_group: {}
    }
  },
  methods: {
    choice (group) {
      this.cur_group = group
    }
  }
}
</script>
